import { Component, OnInit } from '@angular/core';
import { CurrentBasketService } from '../services/current-basket.service';
import { PermissionStorageService } from '../../authentication/storage/permission-storage.service';

@Component({
    selector: 'app-basket-offline',
    templateUrl: './basket-offline.component.html',
    styleUrls: ['./basket-offline.component.scss'],
    standalone: false
})
export class BasketOfflineComponent implements OnInit {
  
  constructor(
    private currentBasketService : CurrentBasketService,
    private permissionStorage: PermissionStorageService
  ) { }

  ngOnInit(): void {
    this.permissionStorage.getPermissions();
  }

  public currentCompany$ =
  this.currentBasketService.currentCompany$;
}
